/*eslint-disable max-len*/
import React, { Component } from 'react';
import * as MaterialUI from '@material-ui/core';

const { SvgIcon } = MaterialUI;

class MoreIcon extends Component {
	constructor(props) {
		super(props);
		this.props = props;
	}

	render() {
		return (
			<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...(this.props)}>
				<circle cx="5" cy="12" r="2" fill="currentColor" fillOpacity="0.75" />
				<circle cx="12" cy="12" r="2" fill="currentColor" fillOpacity="0.75" />
				<circle cx="19" cy="12" r="2" fill="currentColor" fillOpacity="0.75" />
			</SvgIcon>
		);
	}
}

export default MoreIcon;



// WEBPACK FOOTER //
// ./src/components/icons/more.js